import * as actionTypes from './actionTypes'
import { LOGOUT_USER } from '../user/actionTypes'

const initialState = {
    serviceList: { services: [], total: 0, pageSize: 0, error: null, loading: false },
    serviceOfferList: { services: [], total: 0, pageSize: 0, error: null, loading: false },
    activeService: { service: null, error: null, loading: false },
    newService: { service: null, error: null, loading: false },
    updateService: { service: null, error: null, loading: false },
    deleteService: { service: null, error: null, loading: false }
}

export default (state = initialState, action) => {
    switch (action.type) {

        case actionTypes.FETCH_SERVICES:
            return {
                ...state,
                serviceList: {
                    ...state.serviceList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_SERVICES_SUCCESS:
            return {
                ...state,
                serviceList: {
                    services: action.payload.services,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_SERVICES_FAILURE:
            return {
                ...state,
                serviceList: {
                    services: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_SERVICES:
            return { ...state, serviceList: initialState.serviceList }

        case actionTypes.FETCH_SERVICES_OFFER:
            return {
                ...state,
                serviceOfferList: {
                    ...state.serviceOfferList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_SERVICES_OFFER_SUCCESS:
            return {
                ...state,
                serviceOfferList: {
                    services: action.payload.services,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_SERVICES_OFFER_FAILURE:
            return {
                ...state,
                serviceOfferList: {
                    services: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_SERVICES_OFFER:
            return { ...state, serviceOfferList: initialState.serviceOfferList }



        case actionTypes.FETCH_SERVICE:
            return { ...state, activeService: { service: null, error: null, loading: true } }

        case actionTypes.FETCH_SERVICE_SUCCESS:
            return { ...state, activeService: { service: action.payload.service, error: null, loading: false } }

        case actionTypes.FETCH_SERVICE_FAILURE:
            return { ...state, activeService: { service: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_SERVICE:
            return { ...state, activeService: initialState.activeService }



        case actionTypes.CREATE_SERVICE:
            return {
                ...state,
                newService: {
                    service: null,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.CREATE_SERVICE_SUCCESS:
            return {
                ...state,
                newService: {
                    service: action.payload.service,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.CREATE_SERVICE_FAILURE:
            return {
                ...state,
                newService: {
                    service: null,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_CREATE_SERVICE:
            return { ...state, newService: initialState.newService }




        case actionTypes.UPDATE_SERVICE:
            return { ...state, updateService: { service: null, error: null, loading: true } }

        case actionTypes.UPDATE_SERVICE_SUCCESS:
            return { ...state, updateService: { service: action.payload.service, error: null, loading: false } }

        case actionTypes.UPDATE_SERVICE_FAILURE:
            return { ...state, updateService: { service: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_UPDATE_SERVICE:
            return { ...state, updateService: initialState.updateService }



        case actionTypes.DELETE_SERVICE:
            return { ...state, deleteService: { service: null, error: null, loading: true } }

        case actionTypes.DELETE_SERVICE_SUCCESS:
            return { ...state, deleteService: { service: action.payload.service, error: null, loading: false } }

        case actionTypes.DELETE_SERVICE_FAILURE:
            return { ...state, deleteService: { service: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_DELETE_SERVICE:
            return { ...state, deleteService: initialState.deleteService }



        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/service/reducer.js